import { isElementVisible } from '../../shared/utilities';
import { openSlideout } from '../../shared/controllers/slideOutController';

const tripledemicHeroSelect = document.querySelector(
  '[data-tripledemic-hero-select]',
);
const tripledemicHeroSubmit = document.querySelector(
  '[data-tripledemic-hero-submit]',
);
const tripledemicSlideOutForm = document.querySelector(
  '.tripledemicFormSlideout',
);
const tripledemicDesktopForm = document.querySelector(
  '.tripledemicFormDesktop',
);
const slideOut = document.querySelector(`[data-slide-out-name]`);
const mobileSelect = tripledemicSlideOutForm.querySelector('select');
const desktopSelect = tripledemicDesktopForm.querySelector('select');

tripledemicHeroSubmit.addEventListener('click', (e) => {
  e.preventDefault();
  // const href = tripledemicHeroSelect.value;
  activateTripledemicForm();
});
tripledemicHeroSelect.addEventListener('change', (e) => {
  e.preventDefault();
  activateTripledemicForm();
});

function activateTripledemicForm() {
  mobileSelect.value = tripledemicHeroSelect.value;
  desktopSelect.value = tripledemicHeroSelect.value;
  if (isElementVisible(tripledemicDesktopForm)) {
    tripledemicDesktopForm.scrollIntoView({ behavior: 'smooth' });
    desktopSelect.focus();
    desktopSelect.click();
  } else {
    openSlideout(slideOut);
  }
}
